import * as React from "react";
import { Box, Button, Card, CardContent, Chip, Stack, Typography } from "@mui/joy";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Link as RouterLink } from "react-router-dom";
import { useTheme } from "@mui/joy/styles";

import AdminQuotesList from "../components/Admin/AdminQuotesList";

export default function AdminQuotesPage() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const heroBackground = isDark
    ? "linear-gradient(180deg, rgba(15, 23, 42, 0.96) 0%, rgba(10, 15, 26, 0.98) 100%)"
    : "radial-gradient(120% 140% at 8% 0%, rgba(255, 218, 170, 0.2) 0%, rgba(255, 218, 170, 0) 55%), radial-gradient(120% 140% at 95% 5%, rgba(165, 197, 255, 0.2) 0%, rgba(165, 197, 255, 0) 60%), linear-gradient(180deg, rgba(255, 252, 245, 1) 0%, rgba(248, 250, 255, 1) 45%, rgba(244, 246, 252, 1) 100%)";
  const heroOverlay = isDark
    ? "radial-gradient(120% 120% at 15% -10%, rgba(56, 189, 248, 0.14), transparent 60%), radial-gradient(120% 120% at 100% 0%, rgba(251, 191, 36, 0.12), transparent 55%)"
    : "radial-gradient(120% 120% at 15% -10%, rgba(255, 220, 160, 0.45), transparent 60%), radial-gradient(120% 120% at 100% 0%, rgba(129, 158, 255, 0.28), transparent 55%)";
  const heroTitle = isDark ? "rgba(248,250,252,0.94)" : "text.primary";
  const heroBody = isDark ? "rgba(226,232,240,0.8)" : "text.secondary";
  const panelWarm = isDark
    ? "linear-gradient(135deg, rgba(30, 41, 59, 0.9), rgba(15, 23, 42, 0.95))"
    : "linear-gradient(135deg, rgba(255, 237, 213, 0.9), rgba(255, 247, 231, 0.9))";
  const panelCool = isDark
    ? "linear-gradient(135deg, rgba(15, 23, 42, 0.9), rgba(30, 41, 59, 0.95))"
    : "linear-gradient(135deg, rgba(224, 243, 255, 0.8), rgba(241, 249, 255, 0.95))";

  return (
    <Box>
      <Stack spacing={3}>
        <Card
          variant="outlined"
          sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: "xl",
            borderColor: "divider",
            boxShadow: "lg",
            background: heroBackground,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background: heroOverlay,
              opacity: 0.9,
              pointerEvents: "none",
            }}
          />
          <CardContent sx={{ position: "relative" }}>
            <Stack spacing={2}>
              <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems={{ xs: "flex-start", md: "center" }} justifyContent="space-between">
                <Stack spacing={0.75}>
                  <Chip size="sm" variant="soft" color="neutral" sx={{ alignSelf: "flex-start", fontWeight: 600 }}>
                    Daily reflections
                  </Chip>
                  <Typography level="h2" sx={{ fontWeight: 800, color: heroTitle }}>
                    Quote library
                  </Typography>
                  <Typography level="body-sm" sx={{ maxWidth: 680, color: heroBody }}>
                    Curate uplifting meditations that greet every devotee upon opening the dashboard.
                  </Typography>
                </Stack>
                <Button component={RouterLink} to="/quotes/new" startDecorator={<AddRoundedIcon />} variant="soft">
                  New quote
                </Button>
              </Stack>
              <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                <Card
                  variant="soft"
                  sx={{
                    flex: 1,
                    borderRadius: "lg",
                    background: panelWarm,
                    boxShadow: "sm",
                  }}
                >
                  <CardContent>
                    <Typography level="title-sm" sx={{ color: "text.secondary" }}>
                      Morning inspiration
                    </Typography>
                    <Typography level="title-lg" sx={{ mt: 0.5 }}>
                      Set the day’s tone
                    </Typography>
                    <Typography level="body-sm" sx={{ color: "text.secondary" }}>
                      Choose the reflections that open the devotee dashboard each morning.
                    </Typography>
                  </CardContent>
                </Card>
                <Card
                  variant="soft"
                  sx={{
                    flex: 1,
                    borderRadius: "lg",
                    background: panelCool,
                    boxShadow: "sm",
                  }}
                >
                  <CardContent>
                    <Typography level="title-sm" sx={{ color: "text.secondary" }}>
                      Schedule & refine
                    </Typography>
                    <Typography level="title-lg" sx={{ mt: 0.5 }}>
                      Keep the library fresh
                    </Typography>
                    <Typography level="body-sm" sx={{ color: "text.secondary" }}>
                      Rotate quotes to match festivals, seasons, and seva focus.
                    </Typography>
                  </CardContent>
                </Card>
              </Stack>
            </Stack>
          </CardContent>
        </Card>

        <AdminQuotesList />
      </Stack>
    </Box>
  );
}
